export default __webpack_public_path__ + "static/media/Path 59.5a2bf6cf.svg";